import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './styles.css'


export default class SelectSubscriptionType extends Component {
  render() {
    return (
      <div className="subscription-types">
        <Link onClick={() => this.props.onClose()} to="/subscriptions/plans">
          <div className="type">
            <div className="icon">
              <i className="icon-monster-3" />
            </div>
            <span className="name">Individual</span>
            <span>Start a FREE 7-Day Trial of any subscription plan.</span>
          </div>
        </Link>
        <a onClick={() => this.props.onClose()} href="https://pages.stanwinstonschool.com/group-subscription-info-request-v2-swsca/">
          <div className="type">
            <div className="icon">
              <div className="icons-container">
                {new Array(3).fill(null).map((_, iconIndex) => (
                  <i
                    className="icon-monster-2 icon-group"
                    key={iconIndex}
                    role="presentation"
                  />
                ))}
              </div>
            </div>
            <span className="name">Groups</span>
            <span>Get a FREE Demo for your school or organization.</span>
          </div>
        </a>
      </div>
    )
  }
}

SelectSubscriptionType.propTypes = {
  onClose: PropTypes.func.isRequired
}

SelectSubscriptionType.defaultProps = {
  onClose: ()=> {}
}
